module.exports = __webpack_public_path__ + "static/img/004.95973be8.svg";